import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=3b869c81"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b869c81')) {
      api.createRecord('3b869c81', component.options)
    } else {
      api.reload('3b869c81', component.options)
    }
    module.hot.accept("./Cards.vue?vue&type=template&id=3b869c81", function () {
      api.rerender('3b869c81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Cards.vue"
export default component.exports